export default "__VITE_ASSET__DqCtcRAV__"